import { render, staticRenderFns } from "./SettingsSetupChecksListItem.vue?vue&type=template&id=5b28145c"
import script from "./SettingsSetupChecksListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsSetupChecksListItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SettingsSetupChecksListItem.vue?vue&type=style&index=0&id=5b28145c&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports